import React from 'react';
import './Hero.css';

import Google from '../../assets/google.png';
import Apple from '../../assets/apple.png';
import HeroImg from '../../assets/Hero.png';

const Hero = () => {
  return (
    <section className="block hero">
      <div className="container grid grid--1X2">
        <div className="hero__content">
          <h1 className="hero__title">Holla at your favorite Influencer</h1>
          <p className="hero__subtitle">
            Reach out to influencers for information, business collaboration or
            just to say hi, without getting aired or ignored.
          </p>
          <div className="hero__cta-container">
            <button type="button" to="/" className="hero__cta google">
              <div className="hero__cta-logo">
                <img src={Google} alt="" />
              </div>
              <div className="hero__cta-text">
                <p>GET IT ON</p>
                <p>Google Play</p>
              </div>
            </button>

            <button type="button" to="/" className="hero__cta apple">
              <div className="hero__cta-logo">
                <img src={Apple} alt="" />
              </div>
              <div className="hero__cta-text">
                <p>Download on the</p>
                <p>App Store</p>
              </div>
            </button>
          </div>
        </div>
        <div className="hero__image">
          <img src={HeroImg} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
